import React from "react";
import { Field, FieldInputProps, FieldMetaProps } from "formik";
import {
  Stack,
  Text,
  Columns,
  Column,
  TextField,
} from "@origin-digital/ods-core";
import HelperText from "../FormComponents/HelperText";
import AutocompleteField from "../FormComponents/AutocompleteField";
import { ConnectionTypeEnum } from "../../Premises/types";
import { FormValues } from "../types";

const HomeUserLicencedElectrician = () => {
  return (
    <Stack space="large">
      <Text weight="medium">Licenced electrician</Text>
      <Columns
        collapseBelow="md"
        space={{ xs: "none", md: "xlarge" }}
        alignY="stretch"
      >
        <Column width="2/3">
          <Stack space={{ xs: "xlarge", md: "xxlarge" }}>
            <Columns
              collapseBelow="sm"
              space={{
                xs: "xlarge",
                lg: "large",
              }}
            >
              <Column>
                <Field name="homeUserLicencedElectrician.firstName">
                  {({
                    field,
                    meta,
                  }: {
                    field: FieldInputProps<string>;
                    meta: FieldMetaProps<FormValues>;
                  }) => (
                    <TextField
                      {...field}
                      id={field.name}
                      variant="outlined"
                      label="First name"
                      hideHelperTextSpace
                      error={!!meta.error}
                      helperText={meta.error}
                    />
                  )}
                </Field>
              </Column>
              <Column>
                <Field name="homeUserLicencedElectrician.lastName">
                  {({
                    field,
                    meta,
                  }: {
                    field: FieldInputProps<string>;
                    meta: FieldMetaProps<FormValues>;
                  }) => (
                    <TextField
                      {...field}
                      id={field.name}
                      variant="outlined"
                      label="Last name"
                      hideHelperTextSpace
                      error={!!meta.error}
                      helperText={meta.error}
                    />
                  )}
                </Field>
              </Column>
            </Columns>

            <Field name="homeUserLicencedElectrician.companyName">
              {({
                field,
                meta,
              }: {
                field: FieldInputProps<string>;
                meta: FieldMetaProps<FormValues>;
              }) => (
                <TextField
                  {...field}
                  id={field.name}
                  variant="outlined"
                  label="Company Name"
                  hideHelperTextSpace
                  error={!!meta.error}
                  helperText={meta.error}
                />
              )}
            </Field>
            <Field name="homeUserLicencedElectrician.phoneNumber">
              {({
                field,
                meta,
              }: {
                field: FieldInputProps<string>;
                meta: FieldMetaProps<FormValues>;
              }) => (
                <TextField
                  {...field}
                  id={field.name}
                  variant="outlined"
                  label="Phone"
                  hideHelperTextSpace
                  error={!!meta.error}
                  helperText={meta.error}
                />
              )}
            </Field>
            <Field name="homeUserLicencedElectrician.email">
              {({
                field,
                meta,
              }: {
                field: FieldInputProps<string>;
                meta: FieldMetaProps<FormValues>;
              }) => (
                <TextField
                  {...field}
                  id={field.name}
                  variant="outlined"
                  label="Email"
                  hideHelperTextSpace
                  error={!!meta.error}
                  helperText={meta.error}
                />
              )}
            </Field>
            <Field name="homeUserLicencedElectrician.licenseNumber">
              {({
                field,
                meta,
              }: {
                field: FieldInputProps<string>;
                meta: FieldMetaProps<FormValues>;
              }) => (
                <TextField
                  {...field}
                  id={field.name}
                  variant="outlined"
                  label="Licence number"
                  hideHelperTextSpace
                  error={!!meta.error}
                  helperText={meta.error}
                />
              )}
            </Field>
            <Field
              component={AutocompleteField}
              name="connectionType"
              label="Connection type"
              options={[
                { label: "Permanent", value: ConnectionTypeEnum.PERMANENT },
                { label: "Temporary", value: ConnectionTypeEnum.TEMPORARY },
                { label: "Temp in perm", value: ConnectionTypeEnum.TEMPPERM },
              ]}
            />
          </Stack>
        </Column>
        <Column width="1/3">
          <HelperText>
            <Stack>
              <Text variant="body-small" tone="neutralLight">
                <strong>Permanent</strong> - installed in a permanent place.
              </Text>
              <Text variant="body-small" tone="neutralLight">
                <strong>Temporary</strong> - for construction only, to be
                removed when construction ends.
              </Text>
              <Text variant="body-small" tone="neutralLight">
                <strong>Temp in perm</strong> - for construction only, but
                installed in a permanent place and remains on site when
                construction ends.
              </Text>
            </Stack>
          </HelperText>
        </Column>
      </Columns>
    </Stack>
  );
};

export default HomeUserLicencedElectrician;
